var _defs, _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFacebookBlog(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#171717",
    d: "M0 0h30v30H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21 5h-3a5 5 0 00-5 5v3h-3v4h3v8h4v-8h3l1-4h-4v-3a1 1 0 011-1h3V5z",
    fill: "#F8F8F8"
  })));
}

var MemoSvgFacebookBlog = /*#__PURE__*/React.memo(SvgFacebookBlog);
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzAiIGhlaWdodD0iMzAiIHZpZXdCb3g9IjAgMCAzMCAzMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3Qgd2lkdGg9IjMwIiBoZWlnaHQ9IjMwIiBmaWxsPSIjMTcxNzE3Ii8+CjxwYXRoIGQ9Ik0yMSA1SDE4QzE2LjY3MzkgNSAxNS40MDIxIDUuNTI2NzggMTQuNDY0NSA2LjQ2NDQ3QzEzLjUyNjggNy40MDIxNSAxMyA4LjY3MzkyIDEzIDEwVjEzSDEwVjE3SDEzVjI1SDE3VjE3SDIwTDIxIDEzSDE3VjEwQzE3IDkuNzM0NzggMTcuMTA1NCA5LjQ4MDQzIDE3LjI5MjkgOS4yOTI4OUMxNy40ODA0IDkuMTA1MzYgMTcuNzM0OCA5IDE4IDlIMjFWNVoiIGZpbGw9IiNGOEY4RjgiLz4KPC9zdmc+Cg==";
export { MemoSvgFacebookBlog as ReactComponent };